import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { teamsLogout } from '../store/slices/teamsAuthSlice';
import Sidebar from './Sidebar';
import DashboardOverview from './DashboardOverview';
import BillingDashboard from './BillingDashboard';
import BlogSection from './BlogSection';

const MainDashboard = ({ user, msalUser }) => {
  const dispatch = useDispatch();
  const [activeSection, setActiveSection] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleLogout = () => {
    dispatch(teamsLogout());
  };

  const handleSectionChange = (section) => {
    setActiveSection(section);
    if (isMobile) {
      setSidebarOpen(false); // Close sidebar on mobile after section change
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(false); // Close sidebar when switching to desktop
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Listen for navigation events from child components
  useEffect(() => {
    const handleNavigateToBilling = () => {
      setActiveSection('billing');
      if (isMobile) {
        setSidebarOpen(false); // Close sidebar on mobile after navigation
      }
    };

    window.addEventListener('navigate-to-billing', handleNavigateToBilling);
    return () => {
      window.removeEventListener('navigate-to-billing', handleNavigateToBilling);
    };
  }, [isMobile]);

  const renderContent = () => {
    switch (activeSection) {
      case 'dashboard':
        return <DashboardOverview />;
      case 'engagement':
        return (
          <div style={{ padding: '2rem' }}>
            <h2 style={{ color: '#E04F60', marginBottom: '1rem' }}>Engagement Report</h2>
            <div style={{
              backgroundColor: '#f8f9fa',
              borderRadius: '12px',
              padding: '2rem',
              textAlign: 'center'
            }}>
              <h4>📊 Coming Soon!</h4>
              <p style={{ color: '#6c757d' }}>
                Detailed engagement analytics and team performance metrics will be available here.
              </p>
            </div>
          </div>
        );
      case 'blog':
        return <BlogSection />;
      case 'billing':
        return <BillingDashboard user={user} />;
      default:
        return <DashboardOverview />;
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#F4F5F7' }}>
      {/* Mobile Header */}
      {isMobile && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: '60px',
          backgroundColor: '#ffffff',
          borderBottom: '1px solid #e0e0e0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 1rem',
          zIndex: 1001
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <img src="/assets/cheese-512.png" width={24} alt="Ricotta" />
            <span style={{ 
              fontWeight: 'bold', 
              fontSize: '1rem',
              color: '#E04F60' 
            }}>
              Ricotta Dashboard
            </span>
          </div>
          <button
            onClick={toggleSidebar}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              color: '#6c757d',
              cursor: 'pointer',
              padding: '0.25rem'
            }}
          >
            ☰
          </button>
        </div>
      )}

      {/* Sidebar Overlay for Mobile */}
      {isMobile && sidebarOpen && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999
          }}
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <Sidebar 
        activeSection={activeSection}
        onSectionChange={handleSectionChange}
        user={msalUser}
        onLogout={handleLogout}
        isMobile={isMobile}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      
      {/* Main Content */}
      <div style={{
        marginLeft: isMobile ? '0' : '250px',
        marginTop: isMobile ? '60px' : '0',
        flex: '1',
        minHeight: isMobile ? 'calc(100vh - 60px)' : '100vh',
        width: isMobile ? '100%' : 'auto'
      }}>
        {renderContent()}
      </div>
    </div>
  );
};

export default MainDashboard;

